import React from 'react';
import './BenchmarkDonut.scss';
import { SOV_PIE_CHART_PALETTE } from '../../../utils/sovPalette';

// The selected brand's slice colour (green) — same one the real Share of Voice chart injects.
const SELECTED_BRAND_COLOR = '#53CBA2';

// Segments (length + cumulative start on a normalized 0–100 circumference) of the Share of Voice donut,
// coloured with the real SoV palette (selected brand green + competitors).
const SEGMENTS = [
  { len: 40, start: 0, color: SELECTED_BRAND_COLOR },
  { len: 25, start: 40, color: SOV_PIE_CHART_PALETTE[0] },
  { len: 20, start: 65, color: SOV_PIE_CHART_PALETTE[1] },
  { len: 15, start: 85, color: SOV_PIE_CHART_PALETTE[2] },
];

export const BENCHMARK_SEGMENT_COUNT = SEGMENTS.length;

interface BenchmarkDonutProps {
  // 0 = drawing the empty chart, 1 = reviewing competitors (loupe scan), 2 = calculating share.
  phase: number;
  // How many segments are already filled (loops 0→all→0 → the chart keeps building up).
  filled: number;
}

// Staged Share of Voice "benchmark" animation: an empty grey donut that fills segment-by-segment, with a
// competitor-scanning loupe in the centre — synced to the rotating message.
const BenchmarkDonut: React.FC<BenchmarkDonutProps> = ({ phase, filled }) => (
  <span className="benchmark-donut">
    <svg className="benchmark-donut__svg" viewBox="0 0 36 36">
      {/* Empty chart outline (always visible). */}
      <circle className="benchmark-donut__base" cx="18" cy="18" r="15.5" pathLength={100} />
      {/* Filled competitor segments, drawn in as the chart builds up. */}
      {SEGMENTS.map((seg, i) =>
        i < filled ? (
          <circle
            key={i}
            className={`benchmark-donut__seg${
              i === filled - 1 ? ' benchmark-donut__seg--new' : ''
            }`}
            cx="18"
            cy="18"
            r="15.5"
            pathLength={100}
            style={{ stroke: seg.color, strokeDasharray: `${seg.len} 100`, strokeDashoffset: -seg.start }}
          />
        ) : null
      )}
    </svg>

    <span className="benchmark-donut__center">
      {phase === 1 && (
        // Reviewing competitors: a loupe scanning over skeleton rows.
        <span className="benchmark-donut__scan">
          <span className="benchmark-donut__row" />
          <span className="benchmark-donut__row" />
          <span className="benchmark-donut__row" />
          <span className="benchmark-donut__loupe ico--search" />
        </span>
      )}
    </span>
  </span>
);

export default BenchmarkDonut;
